const o=3;export{o as MINIMUM_NO_OF_TILES};
//# sourceMappingURL=constants.js.map
